import React, { useEffect, useState, createRef } from 'react'
import { Link, RichText, Date } from 'prismic-reactjs';
import { Link as ReactLink } from 'react-router-dom'
import ReactDOM from 'react-dom'
import './Footer.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import { faPhoneAlt, faPencilRuler, faBuilding, faLightbulb, faHandPointDown, faClock } from '@fortawesome/free-solid-svg-icons'
import { faHome } from '@fortawesome/free-solid-svg-icons'
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons'
import { faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { withSize } from 'react-sizeme'

const mesureElement = element => {
  const node = ReactDOM.findDOMNode(element.current)
  return {
    width: node.offsetWidth,
    height: node.offsetHeight
  }
}


function Footer(props) {
  const {
    prismicCtx,
    setFooterHeight,
    size
  } = props

  const [doc, setDoc] = useState(null)
  const [footerNotFound, setFooterNotFound] = useState(false)

  const testRef = createRef()

  useEffect(() => {
    if (prismicCtx) {
      prismicCtx.api.getSingle('footer').then(doc => {
        if (doc) {
          setDoc(doc)
        } else {
          setFooterNotFound(true)
        }
      })
    }
  }, [prismicCtx])




  useEffect(() => {
    if (setFooterHeight) {
      setFooterHeight(mesureElement(testRef).height)
    }
  }, [doc, size.width])


  const position = setFooterHeight ? 'absolute' : null

  if (doc) {
    return (
      <footer className='footer__container' style={{ position }} ref={testRef}>
        <div className='footer__row'>
          <div className='footer__col-sm-center col-sm-12 col-md-8 col-lg-4' >
            {doc.data.logo.map((logo, index) => (
              <img key={index} className='footer__logo' src={logo.mynd.url} alt="Framúrskarandi fyrirtæki"/>
            ))}
          </div>
          <div className='footer__col-sm-center  col-sm-12 col-md-8 col-lg-4' >
            <div>
              <h2 className='footer__title'>Flýtileiðir</h2>
            </div>
            <div className='row'>
              {doc.data.flytileidir.map(fl => (
                <div key={fl.linkur.id} className='col-sm-12 col-md-6'>
                  <div className='footer__linkContainer'>
                    <ReactLink
                      to={prismicCtx.linkResolver(fl.linkur)}
                      className='footer__link footer__link-ltr'>
                      {fl.titill[0].text}
                    </ReactLink>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className='footer__col-center col-sm-12 col-md-8 col-lg-4'>
            {doc.data.upplysingar.map((upp, index) => (
              <div key={index} className='footer__upplContainer'>
                {upp.icon === 'Sími' && (
                  <FontAwesomeIcon icon={faPhoneAlt} size={'2x'} style={{ color: upp.iconlitur }} />
                )}
                {upp.icon === 'Stadsetning' && (
                  <FontAwesomeIcon icon={faMapMarkerAlt} size={'2x'} style={{ color: upp.iconlitur }} />
                )}
                {upp.icon === 'Hús' && (
                  <FontAwesomeIcon icon={faHome} size={'2x'} style={{ color: upp.iconlitur }} />
                )}
                {upp.icon === 'Mail' && (
                  <FontAwesomeIcon icon={faEnvelope} size={'2x'} style={{ color: upp.iconlitur }} />
                )}
                {upp.icon === 'Youtube' && (
                  <FontAwesomeIcon icon={faYoutube} size={'2x'} style={{ color: upp.iconlitur }} />
                )}
                {upp.icon === 'Ljósapera' && (
                  <FontAwesomeIcon icon={faLightbulb} size={'2x'} style={{ color: upp.iconlitur }} />
                )}
                {upp.icon === 'Stika og penni' && (
                  <FontAwesomeIcon icon={faPencilRuler} size={'2x'} style={{ color: upp.iconlitur }} />
                )}
                {upp.icon === 'Bygging' && (
                  <FontAwesomeIcon icon={faBuilding} size={'2x'} style={{ color: upp.iconlitur }} />
                )}
                {upp.icon === 'Benda niður' && (
                  <FontAwesomeIcon icon={faHandPointDown} size={'2x'} style={{ color: upp.iconlitur }} />
                )}
                {upp.icon === 'Klukka' && (
                  <FontAwesomeIcon icon={faClock} size={'2x'} style={{ color: upp.iconlitur }} />
                )}


                <p className='footer__upplText'>{upp.upplysingar1[0].text}</p>
              </div>
            ))}
            <div className='row footer__iconContainer-center'>
              <div className='footer__iconContainer'>
                {doc.data.samfelagsmidlar.map((midill, index) => (
                  <React.Fragment key={index}>
                    {midill.icon === 'Facebook' && (
                      <a href={midill.linkur.url} target='_blank' aria-label='Facebook'>
                        <FontAwesomeIcon icon={faFacebookSquare} size='3x' style={{ color: midill.litur }} className='footer__icon' />
                      </a>
                    )}
                    {midill.icon === 'Instagram' && (
                      <a href={midill.linkur.url} target='_blank' aria-label='Instagram'>
                        <FontAwesomeIcon icon={faInstagram} size='3x' style={{ color: midill.litur }} className='footer__icon' />
                      </a>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
      </footer>
    )
  } else {
    return <div ref={testRef}></div>
  }
}

export default withSize()(Footer)